import { createIcon } from '@chakra-ui/icons';

export const StarHalf = createIcon({
  displayName: 'StarHalf',
  viewBox: '0 0 24 24',
  d: 'M12 16.3263L15.78 18.7579L14.79 14.2105L18.12 11.1789L13.74 10.7684L12 6.47368V16.3263ZM4.59 24L6.54 15.1263L0 9.15789L8.64 8.36842L12 0L15.36 8.36842L24 9.15789L17.46 15.1263L19.41 24L12 19.2947L4.59 24Z',
});
